import { Link } from "react-router-dom";
import { Phone, Mail } from "lucide-react";
import { Logo } from "./Logo";
import { useLang } from "../i18n/LanguageContext";
import { CONTACT, waLink } from "../lib/site";

export const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();

  const company = [
    { to: "/services", label: t.nav.services },
    { to: "/about", label: t.nav.about },
    { to: "/resources", label: t.nav.resources },
    { to: "/case-studies", label: t.nav.cases },
    { to: "/contact", label: t.nav.contact },
  ];
  const services = [
    { to: "/services#source", label: t.nav.servicesMenu.source },
    { to: "/services#pay", label: t.nav.servicesMenu.pay },
    { to: "/services#finance", label: t.nav.servicesMenu.finance },
    { to: "/services#move", label: t.nav.servicesMenu.move },
  ];

  return (
    <footer data-testid="site-footer" className="relative bg-sinovar-navy text-white overflow-hidden">
      <div className="mx-auto max-w-7xl px-5 md:px-8 pt-16 md:pt-24 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8">
          <div className="lg:col-span-5">
            <Logo light />
            <p className="mt-5 font-display text-2xl md:text-3xl font-semibold tracking-tight">
              {t.footer.promise}
            </p>
            <p className="mt-4 max-w-sm text-sm text-white/50 leading-relaxed">
              {t.footer.blurb}
            </p>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-xs font-semibold uppercase tracking-[0.14em] text-white/40">{t.footer.navTitle}</h4>
            <ul className="mt-4 space-y-2.5">
              {company.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-white/70 hover:text-white transition-colors" data-testid={`footer-nav-${l.label}`}>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-xs font-semibold uppercase tracking-[0.14em] text-white/40">{t.footer.servicesTitle}</h4>
            <ul className="mt-4 space-y-2.5">
              {services.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-white/70 hover:text-white transition-colors" data-testid={`footer-svc-${l.label}`}>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-xs font-semibold uppercase tracking-[0.14em] text-white/40">{t.footer.contactTitle}</h4>
            <ul className="mt-4 space-y-3">
              <li>
                <a href={waLink(t.hero.waMsg)} target="_blank" rel="noreferrer" className="group flex items-start gap-2.5 text-sm text-white/70 hover:text-white transition-colors" data-testid="footer-cs1">
                  <Phone className="h-4 w-4 mt-0.5 text-sinovar-red" />
                  <span><span className="block text-white/40 text-xs">{t.footer.cs1}</span>{CONTACT.cs1}</span>
                </a>
              </li>
              <li>
                <a href={`https://wa.me/62${CONTACT.cs2.slice(1)}`} target="_blank" rel="noreferrer" className="group flex items-start gap-2.5 text-sm text-white/70 hover:text-white transition-colors" data-testid="footer-cs2">
                  <Phone className="h-4 w-4 mt-0.5 text-sinovar-red" />
                  <span><span className="block text-white/40 text-xs">{t.footer.cs2}</span>{CONTACT.cs2}</span>
                </a>
              </li>
              <li>
                <a href={`mailto:${CONTACT.email}`} className="flex items-start gap-2.5 text-sm text-white/70 hover:text-white transition-colors" data-testid="footer-email">
                  <Mail className="h-4 w-4 mt-0.5 text-sinovar-red" />
                  <span>{CONTACT.email}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 pb-16 lg:pb-0">
          <p className="text-xs text-white/40">© {year} SINOVAR. {t.footer.rights}</p>
          <p className="text-xs text-white/40">China Trade Partner · Indonesia</p>
        </div>
      </div>

      <div className="pointer-events-none select-none w-full overflow-hidden">
        <span className="block font-display font-extrabold tracking-tighter leading-none text-white/[0.04] text-[22vw] text-center">
          SINOVAR
        </span>
      </div>
    </footer>
  );
};
